import {
  ADMINS_REFERRAL_ROUTE,
  POINTSHISTORY_ROUTE,
  PROMOTIONS_ROUTE,
  ACCOUNT_PAYMENT,
  SETTINGS_ROUTE,
  EXAMPLES_ROUTE,
  PATIENTS_ROUTE,
  DOCTORS_ROUTE,
  MAILING_ROUTE,
  REVIEWS_ROUTE,
  REPORTS_ROUTE,
  ACCESS_DENIED,
  ACADEMY_ROUTE,
  COURSE_ROUTE,
  LESSON_ROUTE,
  CHAT_ROUTE,
  MAIN_ROUTE,
  NEWS_ROUTE,
  RATING_ROUTE,
  CASCADE_ROUTE,
} from "./utils/consts";

import PromotionsList from "./pages/PromotionsList";
import NewsList from "./pages/NewsList";
import Settings from "./pages/Settings";
import MainPage from "./pages/MainPage";
import Post from "./pages/Post";

import AdminsReferralInfo from "./components/AdminsReferreralInfo/AdminsReferralInfo";
import CreateUpdateService from "./components/ExamplesService/CreateUpdateService";
import CreateUpdateCollage from "./components/ExamplesService/CreateUpdateCollage";
import ReviewsPage from "./pages/ReviewsPage";
import AccessDenied from "./components/AccessDenied/AccessDenied";
import ReviewRequestPage from "./pages/ReviewRequestPage";
import LessonDetails from "./components/LessonDetails";
import PointsHistory from "./pages/PointsHistory";
import CourseDetails from "./pages/CourseDetails";
import RatingPage from "./pages/RatingPage";
import PaymentPage from "./pages/PaymentPage";
import Examples from "./pages/Examples";
import Patients from "./pages/Patients";
import Doctors from "./pages/Doctors";
import Mailing from "./pages/Mailing";
import Academy from "./pages/Academy";
import Reports from "./pages/Report";
import RatingDetailsPage from "./pages/RatingDetailsPage";
import Doctor from "./pages/Doctor";
import ChatPage from "./pages/ChatPage";
import ChatCategorySettings from "./pages/ChatCategorySettings";
import Cascade from "./pages/Cascade";

export const routes = [
  {
    path: MAIN_ROUTE,
    Component: MainPage,
    // isProtected: true,
  },
  {
    path: CHAT_ROUTE + '/settings',
    Component: ChatCategorySettings,
    isProtected: true,
    requireAccess: ['manageChatCategories'], // Только для тех, кто может управлять категориями
  },
  {
    path: CHAT_ROUTE,
    Component: ChatPage,
    isProtected: true,
    requireAccess: ['chat'], // Только для тех, у кого есть доступ к чатам
  },
  {
    path: NEWS_ROUTE,
    Component: NewsList,
    isProtected: true,
  },
  {
    path: PROMOTIONS_ROUTE,
    Component: PromotionsList,
    isProtected: true,
  },
  {
    path: NEWS_ROUTE + "/:id",
    Component: Post,
    isProtected: true,
  },
  {
    path: PROMOTIONS_ROUTE + "/:id",
    Component: Post,
    isProtected: true,
  },
  {
    path: SETTINGS_ROUTE,
    Component: Settings,
    isProtected: true,
  },
  {
    path: DOCTORS_ROUTE,
    Component: Doctors,
    isProtected: true,
  },
  {
    path: DOCTORS_ROUTE + "/:id",
    Component: Doctor,
    isProtected: true,
  },
  {
    path: CASCADE_ROUTE,
    Component: Cascade,
    isProtected: true,
  },
  {
    path: POINTSHISTORY_ROUTE,
    Component: PointsHistory,
    isProtected: true,
  },
  {
    path: MAILING_ROUTE,
    Component: Mailing,
    isProtected: true,
  },
  {
    path: REVIEWS_ROUTE,
    Component: ReviewsPage,
    isProtected: true,
  },
  {
    path: REVIEWS_ROUTE + "/:id",
    Component: ReviewRequestPage,
    isProtected: true,
  },
  {
    path: RATING_ROUTE,
    Component: RatingPage,
    // isProtected: true,
  },
  {
    path: RATING_ROUTE + "/:id",
    Component: RatingDetailsPage,
    // isProtected: true,
  },
  {
    path: REPORTS_ROUTE,
    Component: Reports,
    isProtected: true,
  },
  {
    path: PATIENTS_ROUTE,
    Component: Patients,
    isProtected: true,
  },
  {
    path: EXAMPLES_ROUTE,
    Component: Examples,
    isProtected: true,
  },
  {
    path: EXAMPLES_ROUTE + '/collage/:id',
    Component: CreateUpdateCollage,
    isProtected: true,
  },
  {
    path: EXAMPLES_ROUTE + "/:id",
    Component: CreateUpdateService,
    isProtected: true,
  },
  {
    path: ACADEMY_ROUTE,
    Component: Academy,
    isProtected: true,
  },
  {
    path: ACADEMY_ROUTE + COURSE_ROUTE + "/:id",
    Component: CourseDetails,
    isProtected: true,
  },
  {
    path: ACADEMY_ROUTE + LESSON_ROUTE + "/:id",
    Component: LessonDetails,
    isProtected: true,
  },
  {
    path: ACCOUNT_PAYMENT,
    Component: PaymentPage,
    // isProtected: true,
  },
  {
    path: ACCESS_DENIED,
    Component: AccessDenied,
  },
  {
    path: ADMINS_REFERRAL_ROUTE,
    Component: AdminsReferralInfo,
    isProtected: true,
  },
];
